import React from 'react';
import PropTypes from 'prop-types';
import { Map, Marker, MarkerLayout } from 'yandex-map-react';
import pointer from 'assets/img/pointerIcon.png';

const YandexMap = ({
  center,
  marker,
  width,
  height,
  zoom,
}) => (
  <Map center={[center.lat, center.lon]} zoom={zoom} width={width} height={height}>
    <Marker lat={marker.lat} lon={marker.lon}>
      <MarkerLayout>
        <div style={{ borderRadius: '10%', overflow: 'hidden' }}>
          <img alt="ThermoTour" style={{ width: '40px', height: '50px' }} src={pointer} />
        </div>
      </MarkerLayout>
    </Marker>
  </Map>
);

YandexMap.propTypes = {
  center: PropTypes.object.isRequired,
  marker: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
};

export default YandexMap;



// WEBPACK FOOTER //
// ./src/components/ui/YandexMap/index.js